//@ts-check
const alp = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

const encode = function encode(num) {
  if (num === 0) {
    return alp[0];
  }
  const len = alp.length;
  let res = '';
  while (num > 0) {
    res = alp[num % len] + res;
    num = Math.floor(num / len);
  }
  return res;
};


const decode = (str) => {
  let res = 0;
  const len = alp.length;
  const strLen = str.length;
  for (let i = 0; i < strLen; i++) {
    let char = str.charCodeAt(i);
    if (char < 58) { // 0-9
      char = char - 48;
    } else if (char < 91) { // A-Z
      char = char - 55;
    } else { // a-z
      char = char - 61;
    }
    res += char * Math.pow(len, strLen - i - 1);
  }
  return res;
};

/**
 * previousIdの次の値を返す。
 * @param {string} [previousId] 
 * @return {string} id
 */
const nextId = (previousId) => {
  const d = decode(previousId || '0');
  return encode(d + 1);
};

/**
 * idList の最大のIDを探して、その次の値を返す。
 * @param {string[]} idList 
 * @returns {string} next id
 */
const nextIdFromList = (idList) => {
  const decodedList = idList.map(id => decode(id));
  const maxDecodedId = decodedList.reduce((max, decodedId) => {
    return Math.max(max, decodedId);
  }, 0);
  return encode(maxDecodedId + 1);
};

export default {
  nextId,
  nextIdFromList,
};